module.exports = "/assets/packs/images/85ff28fcace6e0d7da21f7b03bdedf36.png";